import { Region } from 'generated/generated-graphql'

export const I18nRegionLanguageMap = {
  [Region.UnitedKingdom]: 'en',
  [Region.Australia]: 'en-au',
  [Region.Spain]: 'es',
}

export const I18nToRegionMap = {
  en: Region.UnitedKingdom,
  'en-au': Region.Australia,
  es: Region.Spain,
} as const

export const RegionPriceLocaleMap = {
  [Region.UnitedKingdom]: 'en-GB',
  [Region.Australia]: 'en-AU',
  [Region.Spain]: 'es-ES',
}
